<section style="background-color: #f7f7f7;min-height: 100vh;">
    <span>
        <img src="assets/logo.png" style="height: auto;width: 250px;" alt="">
    </span>
    <h5 style="text-align: center;padding-top: 200px;">Thank You! Your account is verified. You will be redirected to
        your Zipgigz workspace in a while.</h5>
</section>